export const orderHistoryList = () => {
	if ($('.purchase-history-page').length > 0) {
		if ($('.see-more').length > 0) {
			$('.see-more').on('click', function (e) {
				seeDetailsClick(e.target);
			});
			seeDetailsClick($('.see-more')[0]);
			if ($('.print-btn').length > 0) {
				$('.print-btn').on('click', function (e) {
					printBtnClick(e.currentTarget);
				});
			}
		}
		if ($('.ord-status-see-more').length > 0) {
			$('.ord-status-see-more').on('click', function (e) {
				if ($('.lookup-body').hasClass('hidden')) {
					$('.lookup-body').removeClass('hidden');
					$('.ord-status-see-more').text('See Less');
				} else {
					$('.lookup-body').addClass('hidden');
					$('.ord-status-see-more').text('See More');
				}
			});
		}
		$('#online-lookup-submit').on('click', function () {
			if ($('#order-status-search .has-error').length == 0) {
				$('#order-status-search').submit();
			}
		});
	}
};

function togglePopLabelsBtn(table) {
	table[0].querySelectorAll('.popLabelsBtn').forEach((button, index) => {
		$(button).on('click', function () {
			var thisButton = $(this);
			thisButton.next().toggleClass('hidden');
			thisButton.text(thisButton.text() === 'Hide Proof of Purchase Labels' ? 'View Proof of Purchase Labels' : 'Hide Proof of Purchase Labels');
			thisButton.attr('aria-expanded', thisButton.attr('aria-expanded') === 'true' ? 'false' : 'true');
		});
	});		
}

function printBtnClick(buttonClicked) {
	var orderNumber = buttonClicked.getAttribute('data-order-number');
	var mobileAppUrl = '';
	var rsvOrderHistoryDetailUrl = '';
	if (parseInt(orderNumber) <= 99999) {
		mobileAppUrl =
			'/wcs/resources/store/301/purchaseHistory/list/detail?date=' +
			buttonClicked.getAttribute('data-order-date') +
			'&reg=' +
			buttonClicked.getAttribute('data-order-reg') +
			'&store=' +
			buttonClicked.getAttribute('data-order-store') +
			'&tran=' +
			buttonClicked.getAttribute('data-order-tran');
	} else {
		mobileAppUrl =
			'/wcs/resources/store/301/purchaseHistory/list/detail?orderId=' + orderNumber + '&phoneNum=' + buttonClicked.getAttribute('data-phone-number');
		rsvOrderHistoryDetailUrl =
			'/wcs/resources/store/301/purchaseHistory/orderDetail?orderId=' + orderNumber + '&phone=' + buttonClicked.getAttribute('data-phone-number');
	}
	var showReturn = jQuery(buttonClicked).parents('.card').hasClass('completed');
	var orderDate = buttonClicked.getAttribute('data-order-date');
	var orderLocation = buttonClicked.getAttribute('data-order-location') ? buttonClicked.getAttribute('data-order-location') : 'Dillards.com';
	if (orderLocation) {
		if (orderLocation.indexOf(':') > 0) {
			var storeNum = orderLocation.split(':')[0];
			var storeName = orderLocation.split(':')[1];
			var closedStore = orderLocation.split(':')[2];
			orderLocation = storeName;
		}
	}
	callOrderDetailsPrint(mobileAppUrl, rsvOrderHistoryDetailUrl, orderNumber, showReturn, orderDate, orderLocation);
}

function Popup(data) {
	var mywindow = window.open('', 'my div', 'height=800,width=1000');
	try {
		mywindow.focus();
	} catch (e) {
		alert('Pop-ups are blocked, please enable them to print.');
	}
	setTimeout(() => {
		mywindow.document.write("<html><head><title>Dillard's Order Details</title>");
		/*optional stylesheet*/ //mywindow.document.write('<link rel="stylesheet" href="main.css" type="text/css" />');
		mywindow.document.write('</head><body style="font-family:sans-serif;">');
		mywindow.document.write(data);
		mywindow.document.write('</body></html>');
	}, 600);
	setTimeout(() => {
		mywindow.print();
	}, 1200);
	setTimeout(() => {
		mywindow.close();
	}, 3000);
	return true;
}

function seeDetailsClick(buttonClicked) {
	var orderNumber = buttonClicked.getAttribute('data-order-number');
	var mobileAppUrl = '';
	var rsvOrderHistoryDetailUrl = '';
	if (parseInt(orderNumber) <= 99999) {
		mobileAppUrl =
			'/wcs/resources/store/301/purchaseHistory/list/detail?date=' +
			buttonClicked.getAttribute('data-order-date') +
			'&reg=' +
			buttonClicked.getAttribute('data-order-reg') +
			'&store=' +
			buttonClicked.getAttribute('data-order-store') +
			'&tran=' +
			buttonClicked.getAttribute('data-order-tran');
	} else {
		mobileAppUrl =
			'/wcs/resources/store/301/purchaseHistory/list/detail?orderId=' + orderNumber + '&phoneNum=' + buttonClicked.getAttribute('data-phone-number');
		rsvOrderHistoryDetailUrl =
			'/wcs/resources/store/301/purchaseHistory/orderDetail?orderId=' + orderNumber + '&phone=' + buttonClicked.getAttribute('data-phone-number');
	}
	var table = jQuery(buttonClicked).parents('.card').find('table');
	var printSvg = jQuery(buttonClicked).parents('.card').find('.printSvg');
	var showReturn = jQuery(buttonClicked).parents('.card').hasClass('completed');
	var orderDate = buttonClicked.getAttribute('data-order-date') + 'T00:00:00Z';
	var today = new Date();
	// Do not show Start Return for in store orders older than 30 days
	if (new Date(today.getFullYear(), today.getMonth(), today.getDate() + 30) > Date.parse(orderDate) && parseInt(orderNumber) <= 99999) {
		showReturn = false;
	}
	var storeLink = '';
	if (jQuery(buttonClicked).parents('.card').find('.storeLink').length > 0) {
		if (!jQuery(buttonClicked).parents('.card').find('.storeLink').data('store-closed')) {
			storeLink = jQuery(buttonClicked).parents('.card').find('.storeLink').data('store-link');
		}
	}
	if (table.hasClass('expanded')) {
		table.addClass('hidden');
		table.removeClass('expanded');
		$(buttonClicked).text('See More');
	} else {
		$(buttonClicked).text('See Less');
		if (table.hasClass('hidden') && table.hasClass('initialized')) {
			table.removeClass('hidden');
			table.addClass('expanded');
		} else {
			var returnUrl = buttonClicked.getAttribute('data-return-url');
			callOrderDetails(mobileAppUrl, rsvOrderHistoryDetailUrl, table, returnUrl, orderNumber, storeLink, showReturn);
			table.find('.loader').each(function () {
				$(this).css('display', 'block');
			});
			table.removeClass('hidden');
			table.addClass('expanded initialized');
		}
	}
}

function callOrderDetailsPrint(mobileAppUrl, rsvOrderHistoryDetailUrl, orderNumber, showReturn, orderDate, orderLocation) {
	$.ajax({
		type: 'GET',
		url: mobileAppUrl,
		success: (data, textStatus) => {
			const mobileAppResponse = data.response;
			if (rsvOrderHistoryDetailUrl !== '') {
				// call to RSV for 'replacement'
				$.ajax({
					type: 'GET',
					url: rsvOrderHistoryDetailUrl,
					success: (data) => {
						const rsvResponse = data.response;
						const isReplacementOrder = rsvResponse.orderHistoryDetailHeader.replacementOrder;
						mobileAppResponse.replacementOrder = isReplacementOrder;
						mobileAppResponse.orderStatus = rsvResponse.orderHistoryDetailHeader.orderStatus;
						const replacedItems = [];
						const shippingAddresses = rsvResponse.orderHistoryDetailHeader.shippingAddresses;
						shippingAddresses.forEach((address) => {
							const isReplaced = address.items.filter((item) => item.replaced === true);
							isReplaced.forEach((replacedItem) => {
								const replacedItemSku = replacedItem.sku;
								if (!replacedItems.includes(replacedItemSku)) {
									replacedItems.push(replacedItemSku);
								}
							});
						});
						if (replacedItems.length > 0) {
							mobileAppResponse.products.forEach((product) => {
								if (replacedItems.includes(product.sku)) {
									product.replaced = true;
								}
							});
						}
						Popup(buildOrderDetailsPrint(mobileAppResponse, showReturn, orderDate, orderLocation));
					},
					error: () => {
						Popup(buildPrintErrorMessage(orderNumber));
					},
				});
			}
			if (rsvOrderHistoryDetailUrl === '') {
				mobileAppResponse.replacementOrder = false;				
				Popup(buildOrderDetailsPrint(mobileAppResponse, showReturn, orderDate, orderLocation));
			}
		},
		error: (jqXHR, textStatus, errorThrown) => {
			Popup(buildPrintErrorMessage(orderNumber));
		},
	});
}

function callOrderDetails(mobileAppUrl, rsvOrderHistoryDetailUrl, table, returnUrl, orderNumber, storeLink, showReturn) {
	$.ajax({
		type: 'GET',
		url: mobileAppUrl,
		success: (data, textStatus) => {
			const mobileAppResponse = data.response;
			if (rsvOrderHistoryDetailUrl !== '') {
				// call to RSV for 'replacement'
				$.ajax({
					type: 'GET',
					url: rsvOrderHistoryDetailUrl,
					success: (data) => {
						const rsvResponse = data.response;
						const isReplacementOrder = rsvResponse.orderHistoryDetailHeader.replacementOrder;
						mobileAppResponse.replacementOrder = isReplacementOrder;
						mobileAppResponse.orderStatus = rsvResponse.orderHistoryDetailHeader.orderStatus;
						if (isReplacementOrder === false && rsvResponse.orderHistoryDetailHeader.orderStatus === 'Complete') {
							const replacementSkus = [];
							const shippingAddresses = rsvResponse.orderHistoryDetailHeader.shippingAddresses;
							shippingAddresses.forEach((address) => {
								const replacementItems = address.items.filter((item) => item.replaced === true);
								if (replacementItems.length > 0) {
									replacementItems.forEach((replaced) => {
										const replacedSku = replaced.sku;
										replacementSkus.push(replacedSku);
									});
								}
							});
							if (replacementSkus.length > 0) {
								mobileAppResponse.products.forEach((product) => {
									const skuMatch = replacementSkus.filter((sku) => sku === product.sku);
									if (skuMatch.length > 0) {
										product.replaced = true;
										const skuMatchCount = skuMatch.length;
										let replacedMessage = '';
										if (skuMatchCount > 1) {
											replacedMessage = skuMatchCount + ' REPLACED ITEMS';
										} else {
											replacedMessage = skuMatchCount + ' REPLACED ITEM';
										}
										product.replacedMessage = replacedMessage;
									}
								});
							}
						}
						table.find('tbody').remove();
						table.append(buildOrderDetails(mobileAppResponse, returnUrl, storeLink, showReturn));
						togglePopLabelsBtn(table);
						table.find('.print-btn').show();
					},
					error: () => {
						table.find('tbody').remove();
						table.find('thead').remove();
						table.append(buildErrorMessage(orderNumber));
						$('#try-again-' + orderNumber).on('click', function () {
							callOrderDetails(mobileAppUrl, table, returnUrl, orderNumber, storeLink, showReturn);
						});
					},
				});
			}
			if (rsvOrderHistoryDetailUrl === '') {
				mobileAppResponse.replacementOrder = false;
				table.find('tbody').remove();
				table.append(buildOrderDetails(mobileAppResponse, returnUrl, storeLink, showReturn));
				togglePopLabelsBtn(table);
				table.find('.print-btn').show();
			}
		},
		error: (jqXHR, textStatus, errorThrown) => {
			table.find('tbody').remove();
			table.find('thead').remove();
			table.append(buildErrorMessage(orderNumber));
			$('#try-again-' + orderNumber).on('click', function () {
				callOrderDetails(mobileAppUrl, table, returnUrl, orderNumber, storeLink, showReturn);
			});
		},
	});
}

function buildPrintErrorMessage(orderNumber) {
	var errorMessage = `<tbody>
	<tr>
	   <td class="text-center" colspan="2">
		  <div class="alert alert-danger" role="alert" style="font-size: 12px;">
			 Something went wrong, please try again.
			 <br>If the problem continues please check back at a later time or call 1-800-345-5273.</div>
		</td>
	</tr>
	</tbody>`;
	return errorMessage;
}

function buildErrorMessage(orderNumber) {
	var errorMessage =
		`<tbody>
	<tr>
	   <td class="text-center" colspan="2">
		  <div class="alert alert-danger" role="alert" style="font-size: 12px;">
			 Something went wrong, please <a style="text-decoration: underline;cursor:pointer;" id="try-again-` +
		orderNumber +
		`">try again</a>`;

	if (parseInt(orderNumber) > 99999) {
		errorMessage += ` or click the order number above to view details`;
	}

	errorMessage += `. 
			 <br>If the problem continues please check back at a later time or call 1-800-345-5273.</div>
		</td>
	</tr>
	</tbody>`;
	return errorMessage;
}

function buildOrderDetails(mobileAppResponse, returnUrl, storeLink, showReturn) {
	var products = mobileAppResponse.products;
	var orderDetails = `<tbody>`;
	if (mobileAppResponse.orderNumber <= 99999) {
		if (storeLink > '') {
			orderDetails +=
				`<tr><td class="hidden-xl hidden-lg hidden-md mobile-location" colspan="2"><a href=` + storeLink + `>` + mobileAppResponse.storeName + `</a></td></tr>`;
		} else {
			orderDetails += `<tr><td class="hidden-xl hidden-lg hidden-md mobile-location" colspan="2"><p>` + mobileAppResponse.storeName + `</p></td></tr>`;
		}
	}

	products.forEach((element, index) => {
		orderDetails +=
			`<tr>
				<td class="text-center mainImageTd">
				<img class="mainImage" alt="` +
			element.name +
			`" src="`;
		if (element.imageAddress) {
			orderDetails += element.imageAddress + '?ecom132x153';
		} else {
			orderDetails += `https://www.dillards.com/images/dillards-d-logo.svg`;
		}
		orderDetails += `" border="0">
		 </td>
		<td>
			<ul>
				<li class="title">`;
		if (element.keyword) {
			orderDetails += `<a href="/p/` + element.keyword + `/` + element.parentCatentryId + `"> ` + element.name + `</a>`;
		} else {
			orderDetails += `<p>` + element.name + ` </p>`;
		}
		orderDetails += `</li>`
		Object.keys(element.attributes).map(attrName => {
			orderDetails += `<li><strong>${attrName}:</strong><span> ${element.attributes[attrName]}</span></li>`;
		})
		orderDetails +=
			`<li>
				<strong>Qty:</strong><span> ` +
			element.quantity +
			`</span>
				</li>				
				<li>
					<strong>Item Price:</strong><span> $` +
			element.price +
			`</span>
				</li>
				<li>
					<strong>Total Price:</strong><span> $` +
			element.totalPrice +
			`</span>
				</li>				
				<div>
				   <ul class="actions">`;
		if (element.keyword) {
			orderDetails +=
				`<li>
					<a href="/webapp/wcs/stores/servlet/ReviewForm?langId=-1&storeId=301&catalogId=301&partNumber=` +
				element.parentPartNumber +
				`&pr_source=web&productId=` +
				element.parentCatentryId +
				`&productKeyword=` +
				element.keyword +
				`&pr_headline=Product%20Review&pr_headline=Product%20Review">Write a Review</a>
				 </li>`;
		}
		if (element.popLabel.length > 0) {
			orderDetails += `<li>
								<button type="button" aria-controls="popLabelContainer-item-${index}" aria-expanded="true" data-buttonid="item-${index}" class="btn btn-secondary popLabelsBtn">Hide Proof of Purchase Labels</button>` +
								`<div class="${$('body').hasClass("mobilePage") ? 'col-7' : ''}" style="padding:0;border:0;">` +
									`<div id="popLabelContainer-item-${index}" class="popImageContainer">` ;
									element.popLabel.forEach((popNumber) => {
										orderDetails += `<img class="popLabelImage" src='/webapp/wcs/stores/barcode/${popNumber}' data-pop="${popNumber}" />`
									});
			orderDetails += `</div></div></li>`;
		}
		if (mobileAppResponse.orderStatus === 'Complete' && element.returnable === false && element.replaced === undefined) {
			orderDetails += `<li style="font-weight:600;">Not eligible for return</li>`;
		}
		if (element.replaced) {
			orderDetails += `<li style="font-weight:600;">` + element.replacedMessage + `</li>`;
		}
		orderDetails += `			
				 </ul>
				</div>
			</ul>
		</td></tr>`;
	});
	orderDetails +=
		`<tr><td colspan="2" class="totals-block"><div class="row">` +
		`<div class="col-xs-6 col-sm-10"><span>Subtotal:</span></div><div class="col-xs-6 col-sm-2"><span class="dollarAmt">$` +
		mobileAppResponse.merchTotal +
		`</span></div></div>`;
	if (mobileAppResponse.replacementOrder === false) {
		if (mobileAppResponse.shippingCharge) {
			orderDetails +=
				`<div class="row"><div class="col-xs-6 col-sm-10"><span>Shipping:</span></div><div class="col-xs-6 col-sm-2"><span class="dollarAmt">$` +
				mobileAppResponse.shippingCharge +
				`</span></div></div>`;
		}
		if (mobileAppResponse.retailDeliveryFee) {
			orderDetails +=
				`<div class="row"><div class="col-xs-6 col-sm-10"><span>` + mobileAppResponse.retailDeliveryFeeVerbiage +`:</span></div><div class="col-xs-6 col-sm-2"><span class="dollarAmt">$` +
				mobileAppResponse.retailDeliveryFee +
				`</span></div></div>`;
		}
		if (mobileAppResponse.giftWrapCharge) {
			orderDetails +=
				`<div class="row"><div class="col-xs-6 col-sm-10"><span>Gift Wrap:</span></div><div class="col-xs-6 col-sm-2"><span class="dollarAmt">$` +
				mobileAppResponse.giftWrapCharge +
				`</span></div></div>`;
		}
		if (mobileAppResponse.monogramCharge) {
			orderDetails +=
				`<div class="row"><div class="col-xs-6 col-sm-10"><span>Monogram:</span></div><div class="col-xs-6 col-sm-2"><span class="dollarAmt">$` +
				mobileAppResponse.monogramCharge +
				`</span></div></div>`;
		}
		if (mobileAppResponse.discount) {
			orderDetails +=
				`<div class="row"><div class="col-xs-6 col-sm-10"><span>Discount:</span></div><div class="col-xs-6 col-sm-2"><span class="dollarAmt">$` +
				mobileAppResponse.discount +
				`</span></div></div>`;
		}
		if (mobileAppResponse.extraDiscount && mobileAppResponse.extraDiscount != '0') {
			orderDetails +=
				`<div class="row"><div class="col-xs-6 col-sm-10"><span>Extra Discount:</span></div><div class="col-xs-6 col-sm-2"><span class="dollarAmt">$` +
				mobileAppResponse.extraDiscount +
				`</span></div></div>`;
		}
		if (mobileAppResponse.giftWrapDiscount) {
			orderDetails +=
				`<div class="row"><div class="col-xs-6 col-sm-10"><span>Gift Wrap Discount:</span></div><div class="col-xs-6 col-sm-2"><span class="dollarAmt">$` +
				mobileAppResponse.giftWrapDiscount +
				`</span></div></div>`;
		}
		if (mobileAppResponse.monogramDiscount) {
			orderDetails +=
				`<div class="row"><div class="col-xs-6 col-sm-10"><span>Monogram Discount:</span></div><div class="col-xs-6 col-sm-2"><span class="dollarAmt">$` +
				mobileAppResponse.monogramDiscount +
				`</span></div></div>`;
		}
		if (mobileAppResponse.merchDiscount) {
			orderDetails +=
				`<div class="row"><div class="col-xs-6 col-sm-10"><span>Merchandise Discount:</span></div><div class="col-xs-6 col-sm-2"><span class="dollarAmt">$` +
				mobileAppResponse.merchDiscount +
				`</span></div></div>`;
		}
		if (mobileAppResponse.employeeDiscount) {
			orderDetails +=
				`<div class="row"><div class="col-xs-6 col-sm-10"><span>Employee Discount:</span></div><div class="col-xs-6 col-sm-2"><span class="dollarAmt">$` +
				mobileAppResponse.employeeDiscount +
				`</span></div></div>`;
		}
		if (mobileAppResponse.shippingDiscount) {
			orderDetails +=
				`<div class="row"><div class="col-xs-6 col-sm-10"><span>Shipping Discount:</span></div><div class="col-xs-6 col-sm-2"><span class="dollarAmt">$` +
				mobileAppResponse.shippingDiscount +
				`</span></div></div>`;
		}
		if (mobileAppResponse.tax) {
			orderDetails +=
				`<div class="row"><div class="col-xs-6 col-sm-10"><span>Sales Tax:</span></div><div class="col-xs-6 col-sm-2"><span class="dollarAmt">$` +
				mobileAppResponse.tax +
				`</span></div></div>`;
		}
	}
	orderDetails +=
		`<div class="row total"><div class="col-xs-6 col-sm-10"><span><strong>Total:</strong></span></div><div class="col-xs-6 col-sm-2"><span class="dollarAmt">$` +
		mobileAppResponse.total +
		`</span></div></div>` +
		`</td></tr></tbody>`;
	return orderDetails;
}

function buildOrderDetailsPrint(mobileAppResponse, showReturn, orderDate, orderLocation) {
	var products = mobileAppResponse.products;
	var orderDetails = ``;
	if (mobileAppResponse.orderNumber <= 99999) {
		orderDetails += `<p style='margin:0;'>Transaction Id: ` + mobileAppResponse.orderNumber + `</p>`;
		var orderDateToParse = orderDate + 'T12:00:00Z';
		orderDetails += `<p style='margin:0;'>Date: ` + new Date(orderDateToParse).toLocaleDateString() + `</p>`;
		orderDetails += `<p style='margin:0;'>Location: ` + mobileAppResponse.storeName + `</p>`;
	} else {
		orderDetails += `<p style='margin:0;'>Order Number: ` + mobileAppResponse.orderNumber + ` </p>`;
		orderDetails += `<p style='margin:0;'>Date: ` + orderDate + `</p>`;
		orderDetails += `<p style='margin:0;'>Location: ` + orderLocation + `</p>`;
	}
	orderDetails += `<p style='margin:0;'>Items: </p>`;
	products.forEach((element) => {
		for (var i = 0; i < element.quantity; i++) {
			orderDetails +=
				`<ul style='list-style-type: none;'>
					<li><strong>Name:</strong><span> ` +
				element.name +
				` </span></li>`;
			if (element.color !== 'No color') {
				orderDetails +=
					`
					<li>
						<strong>Color:</strong><span> ` +
					element.color +
					`</span>
					</li>`;
			}
			if (element.size !== 'NO SIZE' && element.size !== 'NA') {
				orderDetails +=
					`
					<li>
						<strong>Size:</strong><span> ` +
					element.size +
					`</span>
					</li>`;
			}
			orderDetails +=
				`<li>
					<strong>Item Price:</strong><span> $` +
				element.price +
				`</span>
				</li>`;
			if (mobileAppResponse.orderStatus === 'Complete' && element.returnable === false && element.replaced === undefined) {
				orderDetails += `<li style="font-weight:600;">Not eligible for return</li>`;
			}
			if (
				element.popLabel.length > 0 &&
				element.popLabel[i] > '' &&
				showReturn &&
				((mobileAppResponse.returnable && element.returnable) || mobileAppResponse.orderNumber <= 99999)
			) {
				orderDetails += `<li><strong style="vertical-align: top;">Proof of Purchase Label:</strong><img style="display:block;width:260px;padding:20px 0;" src='/webapp/wcs/stores/barcode/${element.popLabel[i]}' /></li>`;
			} else {
				if (element.replaced) {
					orderDetails += `<li style="font-weight:600;">Replaced</li>`;
				}
			}
			orderDetails += `			
				</ul>`;
		}
	});
	orderDetails += `<ul style="list-style-type: none;padding-left:0px;"><li>Subtotal: $` + mobileAppResponse.merchTotal + `</li>`;
	if (mobileAppResponse.replacementOrder === false) {
		if (mobileAppResponse.shippingCharge) {
			orderDetails += `<li>Shipping: $` + mobileAppResponse.shippingCharge + `</li>`;
		}
		if (mobileAppResponse.retailDeliveryFee) {
			orderDetails += `<li>` + mobileAppResponse.retailDeliveryFeeVerbiage +`: $` + mobileAppResponse.retailDeliveryFee + `</li>`;
		}
		if (mobileAppResponse.giftWrapCharge) {
			orderDetails += `<li>Gift Wrap: $` + mobileAppResponse.giftWrapCharge + `</li>`;
		}
		if (mobileAppResponse.monogramCharge) {
			orderDetails += `<li>Monogram: $` + mobileAppResponse.monogramCharge + `</li>`;
		}
		if (mobileAppResponse.discount) {
			orderDetails += `<li>Discount: $` + mobileAppResponse.discount + `</li>`;
		}
		if (mobileAppResponse.extraDiscount && mobileAppResponse.extraDiscount != '0') {
			orderDetails += `<li>Extra Discount: $` + mobileAppResponse.extraDiscount + `</li>`;
		}
		if (mobileAppResponse.giftWrapDiscount) {
			orderDetails += `<li>Gift Wrap Discount: $` + mobileAppResponse.giftWrapDiscount + `</li>`;
		}
		if (mobileAppResponse.monogramDiscount) {
			orderDetails += `<li>Monogram Discount: $` + mobileAppResponse.monogramDiscount + `</li>`;
		}
		if (mobileAppResponse.merchDiscount) {
			orderDetails += `<li>Merchandise Discount: $` + mobileAppResponse.merchDiscount + `</li>`;
		}
		if (mobileAppResponse.employeeDiscount) {
			orderDetails += `<li>Employee Discount: $` + mobileAppResponse.employeeDiscount + `</li>`;
		}
		if (mobileAppResponse.shippingDiscount) {
			orderDetails += `<li>Shipping Discount: $` + mobileAppResponse.shippingDiscount + `</li>`;
		}
		if (mobileAppResponse.tax) {
			orderDetails += `<li>Sales Tax: $` + mobileAppResponse.tax + `</li>`;
		}
	}
	orderDetails += `<li><strong>Total:</strong> $` + mobileAppResponse.total + `</li> </ul>`;
	return orderDetails;
}